export const DEFAULT_CHAT_PAGE_EXTERNAL_ID = "episto";

// Message the embedded chat posts whenever its theme is applied.
export const CHAT_PAGE_THEME_MESSAGE = "chat-page-theme";

// Demo questionnaire the customizer renders so the theme is seen in context.
export const CHAT_PAGE_PREVIEW_PARAMS = {
  s: "d0fa00129514",
  lg: "fr-kSSu",
  cc: "FR",
  test: "1",
  customizer: "true",
};
